import {isAndroid, isIOS} from "react-device-detect";

const MobileModal = () => {

	const renderContent = () => {
		if (isAndroid) {
			return (
				<a
					className='mobile__google-play-link'
					href='https://play.google.com/store/apps/details?id=mendeleev.redlime&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
				>
					<img
						alt='Get it on Google Play'
						src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
					/>
				</a>
			);
		} else if (isIOS) {
			return (
				<a
					className='mobile__app-store-link'
					href="https://apps.apple.com/us/app/periodic-table-2021-chemistry/id1451726577?itsct=apps_box_badge&amp;itscg=30200">
					<img
						src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1549670400&h=3c39114cbfe6b6c4adbe53ff1a311af0"/></a>
			)
		}
	}

	return (
		<section className='mobile'>
			<div className='mobile__wrapper'/>
			<div className='mobile__apps'>
				<h2 className='mobile__title'>{`Periodic Table ${new Date().getFullYear()}`}</h2>
				<p className='mobile__description'>
					Download the phone app and get even more properties for chemical
					elements
				</p>
				<div className='mobile__store-links'>
					{renderContent()}
				</div>
			</div>
		</section>
	);
};

export default MobileModal;
